export const getInterviewVideoId = (questionId) =>
    `interview-video-${questionId}`;
export const getCultureFitVideoId = () => `culture-fit-video`;

export const isOnlyCultureFitOrOnlyInterview = (scanModules) => {
    const mainModules = scanModules.filter((module) =>
        [
            'culture-fit',
            'speaking',
            'mental-test',
            'questionnaire',
            'culture-fit-questionnaire',
            'data-collection-scan',
        ].includes(module.id),
    );

    if (mainModules.length !== 1) return false;

    const onlyModule = mainModules[0];

    return onlyModule.id === 'culture-fit' || onlyModule.id === 'speaking';
};
